import { getLogger } from '@blueberry/observability'
import { Controller } from 'stimulus'

type AlertType = 'success' | 'error' | 'warning' | 'info'

const logger = getLogger('alert')

/**
 * Dismissal behaviour for BPX alert toasts (see `balance_px/partials/alert.html`).
 * Errors stay until clicked; everything else auto-dismisses after 5s. BPX-owned copy
 * of the shared alert pattern — the bundle globs only `src/balance/controllers`, so
 * px's copy of this controller is never registered here.
 */
export default class extends Controller<HTMLElement> {
  declare typeValue: string
  static values = {
    type: String,
  }

  get type(): AlertType {
    switch (this.typeValue) {
      case 'success':
      case 'error':
      case 'warning':
      case 'info':
        return this.typeValue
    }

    logger.error('Invalid alert type', this.typeValue)
    return 'info'
  }

  connect(): void {
    if (this.type !== 'error') {
      setTimeout(() => {
        this.dismiss()
      }, 5_000)
    }
  }

  dismiss() {
    this.element.remove()
  }
}
